import { FaTachometerAlt, FaBoxOpen } from 'react-icons/fa'
import { FaLocationDot } from 'react-icons/fa6'
import { RiTreeFill, RiMegaphoneFill } from 'react-icons/ri'

import { InternalLink } from 'src/components/atoms/Link'

import {
  dashboardBudgetCalcPath,
  dashboardCarbonCalcPath,
  dashboardPath,
  dashboardToolkitPath,
  donatePath,
  giftingPath,
  supportedProjectsPath
} from 'src/config/paths'
import { trackEvent } from 'src/utils/ga'

export const menuItems = (isBusiness: boolean) => [
  {
    label: 'Dashboard',
    href: dashboardPath(),
    icon: <FaTachometerAlt className='mr-2' />
  },
  {
    label: 'Projects',
    href: supportedProjectsPath,
    icon: <FaLocationDot className='mr-2' />
  },
  {
    label: 'Tools',
    icon: <FaBoxOpen className='mr-2' />,
    children: [
      {
        label: 'Carbon calculator',
        href: dashboardCarbonCalcPath,
        icon: null
      },
      {
        label: 'Funding calculator',
        href: dashboardBudgetCalcPath,
        icon: null
      }
    ]
  },
  ...(isBusiness
    ? [
        {
          label: 'Marketing toolkit',
          href: dashboardToolkitPath,
          icon: <RiMegaphoneFill className='mr-2' />
        }
      ]
    : []),
  {
    label: 'Take action',
    icon: <RiTreeFill className='mr-2' />,
    children: [
      {
        label: 'Fund native trees',
        href: donatePath(),
        icon: null
      },
      {
        label: 'Gifting',
        href: giftingPath,
        icon: null
      }
    ]
  }
]

export const DashboardMenu = ({ isBusiness }: { isBusiness: boolean }) => {
  // We are tracking behavior where non-business funders might choose to click 'donate' vs 'fund'
  const handleFundNativeTreesClick = () => {
    if (!isBusiness) {
      trackEvent('non_business_fund_button', {})
    }
  }
  return (
    <ul className='text-white'>
      {menuItems(isBusiness).map(item => (
        <li key={item.label}>
          {item.children ? (
            <>
              <div className='px-6 py-4 pt-4 pb-2 font-semibold flex items-center'>
                {item.icon}
                <span>{item.label}</span>
              </div>
              <ul className='ml-16 list-disc!'>
                {item.children.map(child => (
                  <li className='mr-8 my-1' key={child.label}>
                    <InternalLink
                      color='white'
                      activeColor='forestDeep'
                      className='flex items-center px-2 py-2.5 hover:bg-limeBright/70 hover:text-forestDeep! cursor-pointer transition-all duration-300 ease-in-out rounded-md'
                      href={child.href}
                      highlightActive
                      activeClassName='bg-limeBright'
                      onClick={
                        child.label === 'Fund native trees'
                          ? handleFundNativeTreesClick
                          : undefined
                      }
                    >
                      {child.icon}
                      <span>{child.label}</span>
                    </InternalLink>
                  </li>
                ))}
              </ul>
            </>
          ) : (
            <InternalLink
              color='white'
              activeColor='forestDeep'
              className='flex items-center py-4 px-6 hover:bg-limeBright/70 hover:text-forestDeep! cursor-pointer transition-all duration-300 ease-in-out'
              href={item.href}
              highlightActive
              activeClassName='bg-limeBright'
            >
              {item.icon}
              <span>{item.label}</span>
            </InternalLink>
          )}
        </li>
      ))}
    </ul>
  )
}
